import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EntryLayout } from '../../components/EntryLayout';
import { FilterChip } from '../../components/FilterChip';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
const activityIds = ['strength', 'running', 'cycling', 'swimming', 'triathlon', 'crossfit', 'mobility', 'mindfulness', 'nutrition'];

/** MOB/Onboarding/Activities — decides which sport metrics appear on the profile. */
export function OnboardingActivities() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    activities,
    toggleActivity
  } = useSession();
  return <EntryLayout title={t('onb.act.title')} body={t('onb.act.body')} step={3} totalSteps={5} footer={<Button variant="gold" size="lg" fullWidth disabled={activities.length === 0} onClick={() => navigate('/onboarding/preferencias')} data-id="element-2986" data-mp="2ovloztosg86o">
          {t('onb.continue')}
        </Button>} data-id="element-2985" data-mp="2yvmejxd93kjb">
      <ul className="flex flex-wrap gap-2" data-id="element-2987" data-mp="1b7vga3etgkw0">
        {activityIds.map(id => <li key={id} data-id="element-2988" data-mp="wihat6ed2nlw">
            <FilterChip label={t(`onb.act.${id}`)} active={activities.includes(id)} onClick={() => toggleActivity(id)} data-id="element-2989" data-mp="wj92w78r237f" />
          </li>)}
      </ul>
    </EntryLayout>;
}